import React from 'react';
import { CheckCircle } from 'lucide-react';

/** Liste à puces avec coche verte : items = [{ titre, texte }] ou chaînes. */
const CheckList = ({ items, className = 'space-y-3 mb-6' }) => (
  <ul className={className}>
    {items.map((item) => {
      const titre = typeof item === 'string' ? null : item.titre;
      const texte = typeof item === 'string' ? item : item.texte;
      return (
        <li key={texte} className="flex items-start gap-3">
          <CheckCircle className="w-6 h-6 text-green-500 flex-shrink-0 mt-1" />
          <span className="text-gray-700">{titre && <strong>{titre}</strong>}{titre ? ' ' : ''}{texte}</span>
        </li>
      );
    })}
  </ul>
);

export default CheckList;
